<template>
  <div id="side-nav-wide" ref="sideNavWide" class="side-nav-info p-3" aria-atomic="true" role="dialog"
    aria-labelledby="dialogLabel" describedby="generalDescription"
    :class="{ 'side-navigation-visible': sideNavigationWideStatus }" v-if="activeSidePanelData && getActiveDataType">
    <div class="wide-image-area-holder" aria-live="polite">
      <transition name="fadeDataArea" mode="out-in">
        <div key="activeComponent" v-if="!activeSubComponent" class="mb-3 activeComponent-container">
          <div class="d-flex justify-content-between">
            <h2 id="dialogLabel">{{ activeSidePanelData.name | ripCode }}</h2>
            <button id="close-button" class="close-button icon-remove" style="font-size: 30px"
              :aria-label="$t('hellovue.sidenav.close')" @click="CloseSideNavigationWide"></button>
          </div>
          <img v-if="subComponentYleisselite[0].imageUrl" :src="subComponentYleisselite[0].imageUrl" class="mb-2"
            :alt="subComponentYleisselite[0].imageAlttext" />
          <div v-if="subComponentYleisselite[0].content" id="generalDescription" class="inactiveComponent-content"
            v-html="subComponentYleisselite[0].content"></div>
        </div>
        <div v-else key="inactiveComponent" class="mb-3 activeSubComponent-container">
          <div class="d-flex justify-content-between">
            <h2>{{ activeSubComponent.name | ripCode }}</h2>
            <button class="close-button icon-remove" style="font-size: 30px" @click="CloseSideNavigationWide"></button>
          </div>
          <img v-if="activeSubComponent.imageUrl" :src="activeSubComponent.imageUrl" class="mb-2"
            :alt="activeSubComponent.imageAlttext" />
          <div v-if="activeSubComponent.content" class="inactiveComponent-content" v-html="activeSubComponent.content">
          </div>
        </div>
      </transition>
    </div>
    <!-- accordion area -->
    <section class="accordion-holder" aria-live="polite">
      <div v-for="contentCategory in contentCategories" class="accordion-parent" :class="contentCategory.name"
        :key="contentCategory.name">
        <button class="
            btn-accordion
            d-flex
            justify-content-between
            align-items-center
            mb-2
          " aria-expanded="false" @click="toggleAccordion($event), toggleChevron($event)">
          <span class="color-dark-blue"><strong>{{ contentCategory | ripCode }}</strong></span><span
            class="icon icon-chevron-down" aria-hidden="true"></span>
        </button>
        <ul class="sidePanelAccordion-wide" aria-hidden="true">
          <li v-for="item in getSidePanelAccordionContent(contentCategory)" :key="item.id">
            <button @click="callDetailedInfo(item, true)" tabindex="-1" v-html="item.description"></button>
            <svg version="1.1" class="mr-2 list-circle" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
              style="enable-background: new 0 0 40 40; height: 40px" xml:space="preserve">
              <path class="st0" d="M20,9C13.9,9,9,13.9,9,20c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C31,13.9,26.1,9,20,9z M20,28.3
          c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3S24.6,28.3,20,28.3z" />
              <path class="outer"
                d="M20,4.5c-8.6,0-15.5,7-15.5,15.5c0,8.6,7,15.5,15.5,15.5c8.6,0,15.5-7,15.5-15.5
          C35.5,11.4,28.6,4.5,20,4.5z M20,31c-6.1,0-11-4.9-11-11c0-6.1,4.9-11,11-11c6.1,0,11,4.9,11,11C31,26.1,26.1,31,20,31z" />
              <path class="st1"
                d="M20,11.7c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S24.6,11.7,20,11.7z" />
            </svg>
          </li>
        </ul>
      </div>
      <!-- connected topics -->
      <div class="accordion-parent" v-if="getLinkedComponents.length">
        <button class="
            btn-accordion
            d-flex
            justify-content-between
            align-items-center
            mb-2
          " aria-controls="connected-topics" aria-expanded="false"
          @click="toggleAccordion($event), toggleChevron($event)">
          <span class="color-dark-blue">
            <strong>Liittyvät aiheet</strong>
          </span>
          <span class="icon icon-chevron-down" aria-hidden="true"></span>
        </button>
        <ul class="sidePanelAccordion-wide" id="connected-topics" aria-hidden="true">
          <li v-for="component in getLinkedComponents" :key="component.id">
            <button v-if="!component[0].imageXCoord" @click="callDetailedInfo(component[0], true)" tabindex="-1"
              v-html="component[0].description"></button>
            <button v-else @click="callDetailedInfo(component[0], true)" tabindex="-1"
              v-html="contentIfComponent(component[0])"></button>
            <svg version="1.1" class="mr-2 list-circle" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
              style="enable-background: new 0 0 40 40; height: 40px" xml:space="preserve">
              <path class="st0" d="M20,9C13.9,9,9,13.9,9,20c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C31,13.9,26.1,9,20,9z M20,28.3
          c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3S24.6,28.3,20,28.3z" />
              <path class="outer"
                d="M20,4.5c-8.6,0-15.5,7-15.5,15.5c0,8.6,7,15.5,15.5,15.5c8.6,0,15.5-7,15.5-15.5
          C35.5,11.4,28.6,4.5,20,4.5z M20,31c-6.1,0-11-4.9-11-11c0-6.1,4.9-11,11-11c6.1,0,11,4.9,11,11C31,26.1,26.1,31,20,31z" />
              <path class="st1"
                d="M20,11.7c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S24.6,11.7,20,11.7z" />
            </svg>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import {
  dataFilters,
  accordionControl,
  accessibilityControls,
} from "src/mixins/mixins.js";
import { dragAndZoom } from "src/mixins/dragAndZoom.js";

export default {
  name: "SideNavigationWide",
  mixins: [dataFilters, accordionControl, accessibilityControls, dragAndZoom],
  data() {
    return {
      activeSubComponent: null,
    };
  },
  computed: {
    ...mapGetters([
      "activeSidePanelData",
      "sideNavigationWideStatus",
      "getSidePanelAccordionContent",
      "getUniqueSidePanelCategories",
      "getActiveDataType",
      "getLinkedComponents",
      "escClicked",
    ]),
    contentCategories: function () {
      return this.getUniqueSidePanelCategories(
        this.activeSidePanelData.name
      ).filter((category) => {
        return category.toLowerCase() != "0:yleisselite";
      });
    },
    sideNavigationSize: function () {
      if (this.sideNavigationWideStatus) {
        return "side-navigation-visible";
      } else {
        return;
      }
    },
    subComponentYleisselite: function () {
      if (this.activeSidePanelData.subComponents) {
        return this.activeSidePanelData.subComponents.filter((obj) => {
          return obj.type.toLowerCase() === "0:yleisselite";
        });
      } else {
        return;
      }
    },
  },
  methods: {
    ...mapActions(["setActiveMapButton", "setEscClicked"]),
    callDetailedInfo(item, status) {
      if (status === true) {
        this.activeSubComponent = item;

        /* Scroll to top of side-nav-info */
        let scrollTargetContainer = document.querySelector(".side-nav-info");
        if (scrollTargetContainer.length) {
          scrollTargetContainer[0].scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        this.activeSubComponent = null;
      }
    },
    CloseSideNavigationWide() {
      // Prompt vue-router to load new route, based on name and given parameters
      this.$router.push({
        name: "componentpage_datatype",
        params: {
          componentName: this.$router.currentRoute.params.componentName,
          view: this.$router.currentRoute.params.view,
          dataType: this.$router.currentRoute.params.dataType,
        },
      });
      //remove active button
      this.changeFocus();
      this.setActiveMapButton(null);
      this.zoom(true, 1);
      this.activeSubComponent = null;
      // accessibility: return focus to previous button
    },
    /**
     * @description if linked component is not subComponent, return description of yleisselite.
     * @returns description
     */
    contentIfComponent: function (component) {
      const componentSubData = component.subComponents.filter((obj) => {
        return obj.type.toLowerCase() === "0:yleisselite";
      });
      return componentSubData[0].description;
    },
    /**
     * @description toggle accordion chevron and call yleiselite, if all current accordions are closed.
     */
    toggleChevron(event) {
      // this.callDetailedInfo(null, false);
      let toggleElements = Array.from(
        event.target.parentElement.parentElement.querySelectorAll(
          ".accordion-parent"
        )
      );

      for (const element of toggleElements) {
        const icon = element.querySelector(".icon");
        if (element.querySelector("BUTTON") != event.target) {
          if (icon && icon.classList.contains("icon-chevron-up")) {
            icon.classList.remove("icon-chevron-up");
            if (!icon.classList.contains("icon-chevron-down")) {
              icon.classList.add("icon-chevron-down");
            }
          }
        } else {
          if (event.target.nextElementSibling.style.maxHeight) {
            icon.classList.remove("icon-chevron-down");
            icon.classList.add("icon-chevron-up");
          } else {
            icon.classList.remove("icon-chevron-up");
            icon.classList.add("icon-chevron-down");
          }
        }
      }
      // if all current accordions are closed, show yleisselite
      const currAccordions = (currValue) =>
        currValue
          .querySelector(".icon")
          .classList.contains("icon-chevron-down");
      if (toggleElements.every(currAccordions)) {
        this.callDetailedInfo(null, false);
      }
    },
  },
  watch: {
    // Triggers when escape is pressed, closes sidenav if it is open
    escClicked: {
      handler(newValue, oldValue) {
        if (newValue === true && this.sideNavigationWideStatus === true) {
          this.CloseSideNavigationWide();
        }
        this.setEscClicked(false);
      },
    },
    /**
     * Accessibility:
     * if true, trap focus in focusable elements in dialog
     * with TAB/SHIFT+TAB trap inside dialog, allow
     * mouse exit
     */
    sideNavigationWideStatus: {
      handler(newValue) {
        if (newValue === true) {
          this.$nextTick(() => {
            const focusableElements = Array.from(
              document
                .querySelector("#side-nav-wide")
                .querySelectorAll("button", "a[href]")
            );
            const wideAccordions = Array.from(
              document
                .querySelector("#side-nav-wide")
                .querySelectorAll(".btn-accordion")
            );

            const lastElem = focusableElements[focusableElements.length - 1];
            document
              .querySelector("#side-nav-wide")
              .addEventListener("keydown", function (event) {
                if (event.key === "Tab" || event.keyCode === 9) {
                  if (event.shiftKey) {
                    if (
                      document.activeElement ===
                      document.querySelector(".close-button")
                    ) {
                      if (lastElem.getAttribute("tabindex") === "-1") {
                        event.preventDefault();
                        wideAccordions[wideAccordions.length - 1].focus();
                      } else {
                        event.preventDefault();
                        lastElem.focus();
                      }
                    }
                  } else {
                    if (
                      lastElem.getAttribute("tabindex") === "-1" &&
                      document.activeElement ===
                      wideAccordions[wideAccordions.length - 1]
                    ) {
                      event.preventDefault();
                      document.querySelector(".close-button").focus();
                    }
                    if (document.activeElement === lastElem) {
                      event.preventDefault();
                      document.querySelector(".close-button").focus();
                    }
                  }
                }
              });
          });
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.side-nav-info {
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: -100%;
  overflow-y: auto;
  position: absolute;
  transition: all 0.3s;
  width: 100%;
  z-index: 2;

  &:last-child {
    margin-bottom: 40px;
  }

  @media (min-width: 1024px) {
    left: -50%;
    width: 35%;
  }

  &.side-navigation-visible {
    left: 0;
  }
}

.accordion-holder {
  overflow-y: unset !important;
}

.close-button {
  background: none;
  border: none;
  width: 45px;
  height: 45px;
}

.btn-accordion {
  background-color: rgba(0, 169, 224, 0.1) !important;
  border: 1px solid deepskyblue;
  cursor: pointer;
  padding: 1rem;
  text-align: left;
  width: 100%;

  span {
    pointer-events: none;
  }
}

.sidePanelAccordion-wide {
  padding: 0 20px;
  background-color: white;
  max-height: 0;
  overflow: hidden;
  list-style-type: none;
  transition: max-height 0.2s ease-out;

  li {
    position: relative;
  }

  button {
    background: transparent;
    border: none;
    text-align: left;
  }
}

.sidePanelAccordion-wide .list-circle {
  position: absolute;
  height: 18px !important;
  left: -13px;
  top: 5px;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}

.side-nav-info .outer {
  stroke: #fff;
  stroke-width: 1px;
  stroke-linejoin: round;
  fill: #00a9e0;
}

.fadeDataArea-enter-active,
.fadeDataArea-leave-active {
  transition: opacity 0.5s;
}

.fadeDataArea-enter,
.fadeDataArea-leave-to {
  opacity: 0;
}

// svg
.side-nav-info .st0 {
  fill: #fff;
}

.side-nav-info .st1 {
  fill: #00a9e0;
}
</style>